export default __webpack_public_path__ + "static/bud-e0d0c6dccf14563becbdb3965f3ef37f.png";